import { useState, useEffect } from 'react';

type SpecialKey = 'ctrl' | 'shift' | 'alt' | 'meta' | string;

export function useKeyPressed(targetKey: SpecialKey) {
  const [pressed, setPressed] = useState(false);

  useEffect(() => {
    const normalize = (key: string) => key.toLowerCase();

    const handleKeyDown = (e: KeyboardEvent) => {
      if (targetKey === 'ctrl' && e.ctrlKey) return setPressed(true);
      if (targetKey === 'shift' && e.shiftKey) return setPressed(true);
      if (targetKey === 'alt' && e.altKey) return setPressed(true);
      if (targetKey === 'meta' && e.metaKey) return setPressed(true);

      if (normalize(e.key) === normalize(targetKey)) {
        setPressed(true);
      }
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      if (targetKey === 'ctrl' && !e.ctrlKey) return setPressed(false);
      if (targetKey === 'shift' && !e.shiftKey) return setPressed(false);
      if (targetKey === 'alt' && !e.altKey) return setPressed(false);
      if (targetKey === 'meta' && !e.metaKey) return setPressed(false);

      if (normalize(e.key) === normalize(targetKey)) {
        setPressed(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [targetKey]);

  return pressed;
}
